<template>
  <div class="dashboardCard">
    <h4 id="title">
      <a :href="dashboardCardContent.route">
        {{ dashboardCardContent.title }}
      </a>
    </h4>
    <div class="dashboardCardContent">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardCard',
  props: {
    dashboardCardContent: {}
  }
}
</script>

<style scoped>
.dashboardCard {
  border: solid black 0px;
  border-radius: 10px;
  margin-right: 20px;
  margin-bottom: 20px;
  box-shadow: 1px 4px 8px 3px rgba(0, 0, 0, 0.1);
  transition: 0.3s;
  padding: 25px;
}

a {
  color: #8b69a9;
  text-decoration: none;
}
</style>
